"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _KonvaShapesEnum = /*#__PURE__*/ _interop_require_default(require("./KonvaShapesEnum.js"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const MarkerPrefix = Object.freeze({
    [_KonvaShapesEnum.default.CIRCLE]: "P",
    [_KonvaShapesEnum.default.LINE]: "L",
    [_KonvaShapesEnum.default.RECTANGLE]: "A",
    [_KonvaShapesEnum.default.ELLIPSE]: "E",
    [_KonvaShapesEnum.default.POLYGON]: "G"
});
const _default = MarkerPrefix;
